import { Component, Input, OnInit } from "@angular/core";
import { AttachmentModel } from "src/app/admin/models/attachment-model";
import {
  AttachmentDto,
  FranchiseDetail,
  GetFranchseSuspensionModel,
} from "src/app/admin/models/franchise-detail";
import { AttachmentTypes } from "src/app/franchise-app-global";
import { AttachmentService } from "src/app/services/AttachmentService";

@Component({
  selector: "app-suspended-section",
  templateUrl: "./suspended-section.component.html",
  styleUrls: ["./suspended-section.component.scss"],
})
export class SuspendedSectionComponent implements OnInit {
  @Input() franchise: FranchiseDetail;
  franchiseSuspension?: GetFranchseSuspensionModel;
  attachment?: AttachmentDto;
  constructor(private attachmentService: AttachmentService) {}

  ngOnInit(): void {
    this.franchiseSuspension = this.franchise?.franchiseSuspension;
    this.attachment = this.franchise?.attachments.find(attachment => attachment.attachmentTypeId == AttachmentTypes.SuspendReason);
  }

  downloadAttachment(): void {
    let fileName = this.attachment?.fileName;
    let publicId = this.attachment?.publicId;
    this.attachmentService.DownloadAdminFile(publicId ?? "", fileName ?? "");
  }
}
